import React, { ReactNode } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

interface ConfirmDialogProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  title?: string
  message?: ReactNode
  confirmText?: string
  cancelText?: string
  danger?: boolean
  closeOnBackdrop?: boolean
  closeOnEscape?: boolean
  confirmOnEnter?: boolean
}

function ConfirmDialog({
  open,
  title = 'Confirm',
  message = 'Are you sure?',
  confirmText = 'OK',
  cancelText = 'Cancel',
  danger = false,
  closeOnBackdrop = true,
  closeOnEscape = true,
  confirmOnEnter = true,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useTranslation()

  return (
    <Modal
      show={open}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={onCancel}
      backdrop={closeOnBackdrop ? true : 'static'}
      keyboard={closeOnEscape}
      animation={false}
      centered
      autoFocus
      restoreFocus
      enforceFocus
    >
      <Modal.Header>
        <Modal.Title>
          <h2 className="text-decoration-none">{title}</h2>
          <button
            type="button"
            className="btn btn-link no-underline btn-lg d-flex justify-content-center align-items-center px-0"
            onClick={onCancel}
          >
            <span>{t('buttons.close')}</span>
            <i className="fal fa-times fa-2x ms-2" />
          </button>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        onKeyDown={(e: React.KeyboardEvent) => {
          if (!confirmOnEnter) return
          if (e.key === 'Enter') {
            e.preventDefault()
            onConfirm()
          }
        }}
      >
        {typeof message === 'string' ? <p className="mb-0">{message}</p> : message}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>

  )
}

ConfirmDialog.defaultProps = {
  title: 'Confirm',
  message: 'Are you sure?',
  confirmText: 'OK',
  cancelText: 'Cancel',
  danger: false,
  closeOnBackdrop: true,
  closeOnEscape: true,
  confirmOnEnter: true,
}

export default ConfirmDialog
